// extracted by mini-css-extract-plugin
module.exports = {"notificationItem":"NotificationItem_notificationItem__O7BdY","iconContainer":"NotificationItem_iconContainer__PthDU","hitBox":"NotificationItem_hitBox__ojOQK"};